import "./style.scss";
import ImageSlider from "../../../ImageSlider/ImageSlider";
import CabinInfo from "./CabinInfo/CabinInfo";
interface ICabinCard {
  cabinDetails: any;
}

const CabinCard: React.FC<ICabinCard> = ({ cabinDetails }) => {
  
  if (!cabinDetails.length) {
    return <span className="pl-5 no-rooms">No Rooms Available</span>
  }

  return (
    <div className="cabin-cards-wrapper flex flex-col gap-3">
      {cabinDetails?.map((room: any, index: number) => {
        return (
          <div className="cabin-card" key={index}>
            <div className="cabin-left-wrapper flex flex-col gap-3">
              <span className="cabin-name text-uppercase underline underline-offset-8 text-muted">{room?.category}</span>
              <div className="cabin-img-wrapper ">
                <ImageSlider controls slide fade={false} indicators={false} interval={5000} imgDataArray={room?.images?.map((imgData: any) => `https://images.cordeliacruises.com${imgData?.src}`)} />
              </div> 
                <span className={`cabin-rooms ${room?.room_count <= 10 ? "red" : "green"}`}>
                  {room?.room_count <= 10 ? "Less Than 10 Cabins Available" : "More Than 10 Cabins Available"}
                </span>
            </div>
            <div className="cabin-details-wrapper flex flex-col gap-3">
              {/* <div className="flex flex-col gap-2">
              </div> */}
              <CabinInfo roomInfo={room} />
              {/* <div className="flex flex-col gap-1 facilities-wrapper">
                {room?.features?.map((feature: any)=> {
                  return <span className="cabin-facilities">{feature}</span> 
                })}
              </div> */}
              {/* <div className="flex flex-col gap-2">
                <div className="flex gap-2 items-center">
                  <SingleBedIconSvg/>
                  <span className="cabin-facilities">{room?.facilities}</span>
                </div>
                <div className="flex gap-2 items-center ml-0.5">
                  <ProfileIconSvg/>
                  <span className="cabin-occupancy ml-0.5">{room?.maxOccupancy}</span>
                </div>
              </div> */}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CabinCard;
